import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import authService from '../../services/authService';

const menuItems = [
  {
    key: 'about',
    title: 'About Us',
    categories: [],
    path: '/about-us'
  },
  {
    key: 'how-it-works',
    title: 'How It Works',
    categories: [],
    path: '/how-it-works'
  },
  {
    key: 'academy',
    title: 'Academy',
    categories: [],
    path: '/academy'
  },
  {
    key: 'graduate-agents',
    title: 'Graduate Agents',
    categories: [],
    path: '/graduate-agents'
  },
  {
    key: 'resources',
    title: 'Resources',
    categories: [],
    path: '/resources'
  },
  {
    key: 'contact',
    title: 'Contact Us',
    categories: [],
    path: '/contact-us'
  }
];

const icons = {
  'trending-up': `<svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none"
    viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 17l6-6 4 4 8-8" />
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 7h7v7" />
  </svg>`,
  'bar-chart-2': `<svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none"
    viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 19V10M12 19V4M20 19v-5" />
  </svg>`,
  'grid': `<svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none"
    viewBox="0 0 24 24" stroke="currentColor">
      <rect x="4" y="4" width="6" height="6" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
      <rect x="14" y="4" width="6" height="6" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
      <rect x="4" y="14" width="6" height="6" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
      <rect x="14" y="14" width="6" height="6" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
  </svg>`,
  'dollar-sign': `<svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none"
    viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v18" />
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M17 5H9a3 3 0 000 6h6a3 3 0 010 6H7" />
  </svg>`,
  'globe': `<svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"/>
    <path d="M2 12h20"/>
  </svg>`,
  'bitcoin': `<svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M11.767 19.089c4.924.868 6.14-6.025 1.216-6.894m-1.216 6.894L5.86 18.047m5.908 1.042-.347 1.97m1.563-8.864c4.924.869 6.14-6.025 1.215-6.893m-1.215 6.893-3.94-.694m5.155-6.2L8.29 4.26m5.908 1.042.348-1.97M7.48 20.364l3.126-17.727"/>
</svg>`
};

const getContactLink = name => {
  switch (name.toLowerCase()) {
    case 'visit us':
      return 'https://maps.app.goo.gl/eeR7TM2ygbjUFURV9';
    case 'phone':
      return 'tel:+27104464170';
    case 'email':
      return 'mailto:support@primemarkets.co.za';
    case 'whatsapp':
      return 'https://wa.me/27104464170';
    default:
      return '#';
  }
};

export default function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [activeMenuMobile, setActiveMenuMobile] = useState(null);
  const [hoverTimeout, setHoverTimeout] = useState(null);
  const [isAnimatingOut, setIsAnimatingOut] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setIsAuthenticated(Boolean(authService.getCurrentUser()));
  }, [location.pathname]);

  const handleLogout = () => {
    authService.logout();
    setIsAuthenticated(false);
    navigate('/', { replace: true });
  };

  // Function to check if current page matches menu item
  const isCurrentPage = (item) => {
    if (item.path) {
      return location.pathname === item.path;
    }
    // For resources or other items without direct paths, you can add custom logic
    return false;
  };

  // Function to check if current page is within resources section
  const isResourcesActive = () => {
    const resourcePaths = [
      '/newssss',
     
    ];
    return resourcePaths.some(path => location.pathname.includes(path.replace('/', '')));
  };

  const handleMouseEnter = (key) => {
    if (key === 'about' || key === 'how-it-works' || key === 'academy' || key === 'graduate-agents' || key === 'contact' || key === 'resources') {
      return;
    }
    // Clear any existing timeout
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
    }
    setIsAnimatingOut(false);
    setActiveMenu(key);
  };

  const handleMouseLeave = () => {
    // Add a longer delay before closing to allow moving to submenu
    const timeout = setTimeout(() => {
      setIsAnimatingOut(true);
      setTimeout(() => {
        setActiveMenu(null);
        setIsAnimatingOut(false);
      }, 300);
    }, 300);
    setHoverTimeout(timeout);
  };

  const handleSubmenuMouseEnter = () => {
    // Clear timeout when entering submenu
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
    }
    setIsAnimatingOut(false);
  };

  const handleSubmenuMouseLeave = () => {
    // Close submenu when leaving with longer delay
    const timeout = setTimeout(() => {
      setIsAnimatingOut(true);
      setTimeout(() => {
        setActiveMenu(null);
        setIsAnimatingOut(false);
      }, 300);
    }, 300);
    setHoverTimeout(timeout);
  };

  const toggleMobileMenu = (key) => {
    if (key === 'about') {
      navigate('/about-us');
      setIsMobileMenuOpen(false);
      return;
    }
    if (key === 'how-it-works') {
      navigate('/how-it-works');
      setIsMobileMenuOpen(false);
      return;
    }
    if (key === 'academy') {
      navigate('/academy');
      setIsMobileMenuOpen(false);
      return;
    }
    if (key === 'graduate-agents') {
      navigate('/graduate-agents');
      setIsMobileMenuOpen(false);
      return;
    }
     if (key === 'resources') {
      navigate('/resources');
      setIsMobileMenuOpen(false);
      return;
    }
    if (key === 'contact') {
      navigate('/contact-us');
      setIsMobileMenuOpen(false);
      return;
    }
    setActiveMenuMobile(prev => (prev === key ? null : key));
  };

  const handleMenuClick = (key) => {
    switch (key) {
      case 'about':
        navigate('/about-us');
        break;
      case 'how-it-works':
        navigate('/how-it-works');
        break;
      case 'academy':
        navigate('/academy');
        break;
      case 'graduate-agents':
        navigate('/graduate-agents');
        break;
      case 'resources':
        navigate('/resources');
        break;
      case 'contact':
        navigate('/contact-us');
        break;
      default:
        break;
    }
  };

  const getIcon = name => icons[name] || '';

  const redirect = value => {
    const accountsList = ['individual account', 'joint account', 'islamic account', 'demo account', 'corporate account'];
    
    if (accountsList.includes(value)) {
      navigate(`/accounts#${value.split(' ')[0]}`);
    } else if(value.toLowerCase() === 'cfd trading') {
      navigate('/cfd-trading');
    } else if(value.toLowerCase() === 'account types') {
      navigate('/accounts');
    } else if (value.toLowerCase() === 'fees and charges') { 
      navigate('/cfd-trading/our-changes');
    } else {
      navigate(`/${value.replaceAll(' ', '-').toLowerCase()}`);
    }
    setIsMobileMenuOpen(false);
    setActiveMenu(null);
    setActiveMenuMobile(null);
  };

  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  useEffect(() => {
    // Clear timeout on component unmount
    return () => {
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
      }
    };
  }, [hoverTimeout]);

  const pathNameValue = window.location.pathname;
  const activeMenuData = menuItems.find(item => item.key === activeMenu);

  return (
    <div ref={navRef} className="sticky top-0 z-50">
      {/* <div className="bg-gray-200 text-black p-3 text-center text-[10px] md:text-xs">
        Trading CFDs requires skill, knowledge, and a clear understanding of the associated risks.
        Leveraged trading, in particular, carries a significant risk of losing all invested funds in a
        short period and may not be suitable for everyone.
      </div> */}
      <nav className="relative flex flex-col md:flex-row h-[70px] md:h-[100px] items-center p-4 shadow-md bg-white text-black">

        <div className="md:hidden flex items-center w-full">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="text-gray-700 focus:outline-none p-2"
          >
            &#9776;
          </button>
          <Link to="/">
            <img
              className="h-8 sm:h-10 w-auto"
              style={{ objectFit: 'contain' }}
              src="Images/logo.png"
              alt="Mzansi Logo"
            />
          </Link>
        </div>

        <div className="hidden w-full md:flex flex-row items-center justify-between">
          <Link to="/">
            <img
              className="h-64 md:h-64 object-contain"
              src="Images/logo.png"
              alt="MZANSI Logo"
            />
          </Link>
          <div className="flex-1 flex justify-center gap-10">
            {menuItems.map(item => (
              <div
                key={item.key}
                className="relative group"
                onMouseEnter={() => handleMouseEnter(item.key)}
                onMouseLeave={handleMouseLeave}
              >
                <button
                  onClick={() => handleMenuClick(item.key)}
                  className={`
                    ${activeMenu === item.key ? 'border-b-2 border-[#4bcfe1]' : ''} 
                    ${isCurrentPage(item) || (item.key === 'news' && isResourcesActive()) ? 'border-b-2 border-[#4bcfe1] text-[#4bcfe1]' : 'text-gray-700'} 
                    focus:outline-none text-sm md:text-lg cursor-pointer py-2 px-4 transition-colors duration-200
                  `}
                >
                  {item.title}{item.categories.length > 0 && ' '}
                </button>
              </div>
            ))}
          </div>
          <div className="flex items-center space-x-4">
            {!isAuthenticated && (
              <Link to="/login" style={{color:"white"}} className="w-[100px] text-center bg-slate-800 text-white px-3 py-1 md:px-4 md:py-2 rounded text-xs md:text-base">
                Login
              </Link>
            )}
            {isAuthenticated && (
              <button
                type="button"
                onClick={handleLogout}
                className="w-[100px] text-center bg-white text-slate-800 px-3 py-1 md:px-4 md:py-2 rounded text-xs md:text-base border border-slate-300 hover:bg-slate-100"
              >
                Logout
              </button>
            )}
            <a
              href="http://mzansisave.co.za/msansisave.apk"
              className="bg-[#4bcfe1] text-white px-3 py-1 md:px-4 md:py-2 rounded text-xs md:text-base"
            >
              Get Started
            </a>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <>
            <div
              className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm z-40"
              onClick={closeMobileMenu}
            />
            <div
              className={`fixed left-0 top-0 h-full w-72 bg-white shadow-xl p-6 transform transition-transform duration-300 ease-in-out z-50 ${
                isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'
              }`}
            >
              <button
                onClick={closeMobileMenu}
                className="text-gray-700 focus:outline-none absolute top-4 right-4 text-2xl"
              >
                &times;
              </button>
              <Link to="/" onClick={closeMobileMenu}>
                <img
                  className="h-10 w-full object-contain"
                  src="Images/logo.png"
                  alt="Mzansi Logo"
                />
              </Link>
              <div className="mt-4">
                {menuItems.map(item => (
                  <div key={item.key} className="mt-4">
                    <button
                      onClick={() => toggleMobileMenu(item.key)}
                      className={`
                        ${isCurrentPage(item) || (item.key === 'news' && isResourcesActive()) ? 'text-[#4bcfe1] font-semibold' : 'text-gray-700'}
                        focus:outline-none text-lg block w-full text-left py-2 border-b border-gray-200 transition-colors duration-200
                      `}
                    >
                      {item.title}{item.categories.length > 0 && <span className="float-right"></span>}
                    </button>
                    {activeMenuMobile === item.key && (
                      <div className="ml-4 mt-2">
                        <ul className="space-y-2">
                          {item.categories.map(category => (
                            <li key={category.title}>
                              <h4 className="font-semibold mt-2">{category.title}</h4>
                              <ul>
                                {category.items.map(sub =>
                                  category.title === 'Contact Prime Markets' ? (
                                    <li key={sub.name} className="py-1">
                                      <a
                                        href={getContactLink(sub.name)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="hover:text-[#4bcfe1]"
                                      >
                                        {sub.name}
                                      </a>
                                    </li>
                                  ) : (
                                    <li
                                      key={sub.name}
                                      className="py-1 cursor-pointer hover:text-[#4bcfe1]"
                                      onClick={() => redirect(sub.name.toLowerCase())}
                                    >
                                      {sub.name}
                                    </li>
                                  )
                                )}
                              </ul>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </>
        )}

        {/* Desktop Hover Menu */}
        {activeMenuData && (
          <div
            className={`absolute bg-gray-100 shadow-lg p-4 md:p-6 border border-gray-200 w-full left-0 z-50 ${
              isAnimatingOut ? 'animate-slideUp' : 'animate-slideDown'
            }`}
            style={{ top: '100%' }}
            onMouseEnter={handleSubmenuMouseEnter}
            onMouseLeave={handleSubmenuMouseLeave}
          >
            <div className="flex flex-col md:flex-row gap-4">

              {activeMenu === 'news' ? (
                <div className="flex flex-col md:flex-row gap-4 flex-1">
                  {activeMenuData.categories.map(category => (
                    <div
                      key={category.title}
                      className="p-4 border-b md:border-r border-gray-300 w-full md:w-[500px]"
                    >
                      <h3 className={`text-gray-900 font-semibold text-lg mb-3 ${category.title =='Platforms' ? 'cursor-pointer' : ''}`} onClick={() => category.title == 'Platforms' ? window.location.href = 'https://prime.primemarkets.co.za/primemarket' : ''}>{category.title}</h3>
                      <ul className="space-y-3 text-sm text-gray-700">
                        {category.items.map(sub => {
                          if (category.title === 'Contact Prime Markets') {
                            return (
                              <li key={sub.name}>
                                <a
                                  href={getContactLink(sub.name)}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="flex py-3 px-2 hover:bg-gray-200 cursor-pointer items-start space-x-3 rounded"
                                >
                                  <div
                                    className="text-[#4bcfe1]"
                                    dangerouslySetInnerHTML={{ __html: getIcon(sub.icon) }}
                                  />
                                  <div>
                                    <p className="font-medium">{sub.name}</p>
                                    <p className="text-xs text-gray-500">{sub.description}</p>
                                  </div>
                                </a>
                              </li>
                            );
                          }
                          return (
                            <li
                              key={sub.name}
                              onClick={() => redirect(sub.name.toLowerCase())}
                              className={`flex py-3 px-2 hover:bg-gray-200 cursor-pointer items-start space-x-3 rounded ${
                                pathNameValue.includes(sub.name.toLowerCase().replace(/\s+/g, '-')) ? 'bg-[#4bcfe1] text-white' : ''
                              }`}
                            >
                              <div
                                className="text-[#4bcfe1]"
                                dangerouslySetInnerHTML={{ __html: getIcon(sub.icon) }}
                              />
                              <div>
                                <p className="font-medium">{sub.name}</p>
                                <p className={`text-xs ${
                                  pathNameValue.includes(sub.name.toLowerCase().replace(/\s+/g, '-'))
                                    ? 'text-white'
                                    : 'text-gray-500'
                                }`}>
                                  {sub.description}
                                </p>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  ))}
                  {/* indicator */}
                  {activeMenu === 'about' && (
                    <div className="p-4 border-b md:border-r border-gray-300 w-full md:w-[500px]">
                      <h3 className="text-gray-900 font-semibold text-lg mb-3">Location</h3>
                      <iframe
                        title="Prime Markets Location"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3460.145507467466!2d31.021776874802!3d-29.860077222750096!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1ef7a9c827e8faa9%3A0xfe80e7547dc65388!2s301%20Anton%20Lembede%20St%2C%20Durban%20Central%2C%20Durban%2C%204001!5e0!3m2!1sen!2sza!4v1746559256685!5m2!1sen!2sza" 
                        height="400"
                        width="100%"
                        frameBorder="0"
                        style={{ border: 0 }}
                        allowFullScreen
                        loading="lazy"
                      />
                    </div>
                  )}
                </div>
              ) : (
                <div className="grid grid-cols-2 md:grid-cols-1 gap-4 flex-1">
                  {activeMenuData.categories.map(category => (
                    <div key={category.title} className="col-span-1">
                      <h3 className="text-gray-900 font-semibold text-lg mb-3">{category.title}</h3>
                      <div className="flex flex-wrap gap-4">
                        {category.items.map(sub => (
                          <div
                            key={sub.name}
                            onClick={() => redirect(sub.name.toLowerCase())}
                            className="w-full md:w-60 hover:bg-gray-200 transition duration-500 cursor-pointer ease-in-out rounded-lg p-4 flex flex-col"
                          >
                            <img src={sub.imageURL} alt={sub.name} className="h-32 w-full object-cover mb-3 rounded" />
                            <h3 className="text-sm text-gray-700 font-semibold mb-2">{sub.name}</h3>
                            <p className="text-gray-500 mb-4 text-sm">{sub.description}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              )}

              <div className="hidden lg:block" style={{ width: '27%' }}>
                <div className="flex flex-col items-center p-4">
                  {/* Additional content can be added here if needed */}
                </div>
              </div>

            </div>
          </div>
        )}
      </nav>
    </div>
  );
}
